import RatingsList from './RatingsList';

export default RatingsList;
